export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";